<template>
	<audio></audio>
</template>

<script>

export default {
	name: "AuditionAudio",

	computed: {
		source() {
			return this.$store.getters.getWebRTCStream();
		},

		activeStudioPlayoutOutputDevice() {
			//for backwards compatibility reasons, if playout output device has not set, we get the audition output device
			return this.$store.getters.getActiveStudioPlayoutOutputDevice() ??
				   this.$store.getters.getActiveStudioAuditionOutputDevice();
		}
	},

	watch: {
		activeStudioPlayoutOutputDevice() {
			this.setOutputDevice();
		},

		source(stream) {
			this.$el.srcObject = stream;
			if (stream) {
				this.$el.play();
			}
			else {
				this.$el.pause();
			}
		}
	},

	mounted() {
		this.setOutputDevice();
		// Dockview's popout mechanism (moving a panel's DOM into a separate browser
		// window via addPopoutGroup) detaches and reattaches panel content from its
		// shared render container. That detach/reattach makes Chrome pause any
		// <audio>/<video> element on the page as a side effect, even ones - like this
		// one - that live outside the panel being moved. Since our `source` watcher
		// only calls play()/pause() when the actual stream reference changes, a pause
		// triggered externally like this leaves playback stopped indefinitely even
		// though the stream is still live. Resume automatically whenever we're paused
		// but still have a stream we intend to be playing.
		this.$el.addEventListener("pause", this.resumeIfStreamStillLive);
	},

	beforeUnmount() {
		this.$el.removeEventListener("pause", this.resumeIfStreamStillLive);
	},

	methods: {
		setOutputDevice() {
			this.$el.setSinkId(this.activeStudioPlayoutOutputDevice?.device ?? "default");
		},

		resumeIfStreamStillLive() {
			if (this.source) {
				this.$el.play();
			}
		}
	}
}
</script>

<style scoped>

</style>